import { Component, Input } from '@angular/core';
import { BarChartOptions } from '../../services/chart-helper.service'

@Component({
  selector: 'app-lcv-ev-by-entity',
  templateUrl: './lcv-ev-by-entity.component.html',
  styleUrls: ['./lcv-ev-by-entity.component.scss']
})
export class LcvEvByEntityComponent {
  @Input() selectedToggle: string = '';
  @Input() evChartOptions: BarChartOptions | null = null;
}
